import SortIcon from "../SortIcon/SortIcon";
import { bookExtractHeaders } from "../BookTable/headers";
import type { SortState } from "../BookExtracts/types";
import "./BookSortControl.scss";

interface BookSortControlProps {
  sort: SortState | null;
  onSort: (key: string) => void;
}

function BookSortControl({ sort, onSort }: BookSortControlProps) {
  const sortableHeaders = bookExtractHeaders.filter((header) => header.sortable);

  return (
    <div className="book-sort">
      <span className="book-sort__label">Sort by</span>
      <div className="book-sort__chips">
        {sortableHeaders.map((header) => {
          const isActive = sort?.key === header.key;

          return (
            <button
              key={header.key}
              type="button"
              className={`book-sort__chip${isActive ? " book-sort__chip--active" : ""}`}
              aria-pressed={isActive}
              onClick={() => onSort(header.key)}
            >
              {header.label}
              {isActive && <SortIcon direction={sort?.direction ?? null} single />}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default BookSortControl;
